import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseLayout } from '../../../interfaces/base-layout.interface';
import { ClientCvTemplate } from '../../../interfaces/client-cv-template.interface';
import { StudioSelection } from '../studio.component';
import { Globals } from '../../../shared/Globals';

@Component({
  selector: 'bst-cv-studio-rail',
  templateUrl: './studio-rail.component.html',
  styleUrls: ['./studio-rail.component.scss'],
  standalone: false,
})
export class StudioRailComponent {
  @Input() baseLayouts: BaseLayout[] = [];
  @Input() templates: ClientCvTemplate[] = [];
  @Input() selection: StudioSelection | null = null;
  @Input() loading = false;
  @Output() selectionChange = new EventEmitter<StudioSelection>();

  public isBuiltinSelected(id: string): boolean {
    return this.selection?.type === 'builtin' && this.selection.layout.id === id;
  }

  public isCustomSelected(id: number): boolean {
    return this.selection?.type === 'custom' && this.selection.template.id === id;
  }

  public isThemeSelected(): boolean {
    return this.selection?.type === 'theme';
  }

  public isHouseSelected(): boolean {
    return this.selection?.type === 'house';
  }

  public pickBuiltin(layout: BaseLayout): void {
    this.selectionChange.emit({ type: 'builtin', layout });
  }

  public pickCustom(template: ClientCvTemplate): void {
    this.selectionChange.emit({ type: 'custom', template });
  }

  public pickTheme(): void {
    this.selectionChange.emit({ type: 'theme' });
  }

  public pickHouse(): void {
    this.selectionChange.emit({ type: 'house' });
  }

  public requestUpload(): void {
    this.selectionChange.emit({ type: 'upload' });
  }

  public thumbnailUrl(t: ClientCvTemplate): string | null {
    const fe = t.first_page_thumbnail as { url?: string | null; preview?: string | null } | undefined;
    return fe?.url ?? Globals.storage(fe?.preview ?? undefined);
  }
}
